import { ReactElement } from 'react';
import English from './en.json';
import Spanish from './es.json';
import { IntlProvider } from 'react-intl';
import { useLanguage } from '@xolv-mybrightlink/common';

type I18nProps = {
  children: ReactElement;
};

export const I18n = ({ children }: I18nProps) => {
  const { language } = useLanguage();
  const messages = language === 'es' ? Spanish : English;
  return (
    <IntlProvider locale={language} messages={messages}>
      {children}
    </IntlProvider>
  );
};
